import { Radio, RadioGroup, Text } from '@chakra-ui/react';
import { RADIO_GROUP_SX } from './utils/radioGroupStyles';

const BALANCE_RADIO_SX = {
  ...RADIO_GROUP_SX,
  '.chakra-radio__label': {
    ...RADIO_GROUP_SX['.chakra-radio__label'],
    ml: '10px',
  },
};

interface BalanceNumberTypeRadioProps {
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
}

const BalanceNumberTypeRadio = ({
  value,
  onChange,
  onFocus,
}: BalanceNumberTypeRadioProps) => (
  <RadioGroup
    value={value}
    onChange={onChange}
    display="flex"
    flexDirection="column"
    gap={3}
    mt={2}
    ml={1}
    sx={BALANCE_RADIO_SX}
  >
    <Radio value="integer" onFocus={onFocus}>
      <Text fontSize="13px">Integer</Text>
    </Radio>
    <Radio value="decimal" onFocus={onFocus}>
      <Text fontSize="13px">Decimal</Text>
    </Radio>
  </RadioGroup>
);

export default BalanceNumberTypeRadio;
